module.exports = __webpack_public_path__ + "img/pest.036e1294.png";